import { defineMessages } from 'react-intl-next';

const messages: {
	pageIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	portalDownIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	portals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	pageIcon: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.page-icon.non-final',
		defaultMessage: 'Page icon',
		description: 'Icon label for the page icon',
	},
	portalDownIcon: {
		defaultMessage: 'Open portals dropdown',
		description: 'Icon label for the chevron down icon',
		id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-down.non-final',
	},
	portals: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.portals.non-final',
		defaultMessage: 'Portals',
		description: 'Navigation link label for the portals dropdown',
	},
});

export default messages;
